/**
 * RefreshButton - Manual data refresh with loading state
 */

import React from 'react';
import { RefreshCw } from 'lucide-react';

const RefreshButton = ({ onClick, loading = false, label = 'Refresh' }) => {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className="flex items-center space-x-1 px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      aria-label={label}
    >
      <RefreshCw size={14} className={loading ? 'animate-spin' : ''} />
      <span>{label}</span>
    </button>
  );
};

export default React.memo(RefreshButton);
